import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getDashboardTableFilings } from '../../../features/state/StateFiling-slice';

export const useWorkQueueController = (props: any) => {
  const {} = props;

  // ColumnName
  //    Status (statusId)

  // New
  //    New (standard) (1)
  //    New (non-substantial) (25)
  //    New (emergency) (24)
  // Public Hearing Pending
  //    Ready for Public Hearing (2)
  //    Public Hearing - Pending (3)
  // Attorney General's Office Pending
  //    AG - Pending (6)
  //    AG - Returned to Agency (9)
  // Governor's Office Pending
  //    GPRO - Pending (standard, non-substantive) (10)
  //    GPRO - Pending (emergency) (26)
  //    GPRO - Returned to Agency (standard, non-substantive) (13)
  //    GPRO - Returned to Agency (emergency) (28)
  // Secretary of State Office Pending
  //    SOS - Pending (14)
  //    Ready for Promulgation (15)
  const [taskBoardColumns, setTaskboardColumns] = useState<any>([
    { id: 1, title: 'New', status: 'new' },
    { id: 2, title: 'Public Hearing Pending', status: 'publicHearingPending' },
    { id: 3, title: `Attorney General's Office Pending`, status: 'agPending' },
    { id: 4, title: `Governor's Office Pending`, status: 'gproPending' },
    { id: 5, title: 'Secretary of State Office Pending', status: 'sosPending' },
    { id: 6, title: 'Ready for Promulgation', status: 'readyForPromulgation' },
  ]);
  const filings = useAppSelector((state) => state.filings.dashboardFilings);
  const loading = useAppSelector((state) => state.filings.fetchingDashboardFilings);
  // const taskBoardColumns = useAppSelector((state) => state.taskBoardColumns.value);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (filings.length < 1) {
      dispatch(getDashboardTableFilings())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    // functions
    // state
    taskBoardColumns,
    filings,
    loading,
    // props
  };
};
